<template>
  <div class="bg-white">
    <div class="padding-lr">
      <h3 class="notice-title">{{ title }}</h3>
      <p class="notice-time">{{time}}</p>
      <div v-html="content" class="notice-detial"></div>
    </div>
  </div>
</template>

<script>
import {noticeDetail} from "@/api/notice";
import {zhDate} from "@/utils/utils";

export default {
  name: "notice-detail",
  data() {
    return {
      title: '',
      time:'',
      content: '',
    }
  },
  created() {
    this.$emit("setIndex", '/home/notice', "通知公告 / 详情", true);
    this.getDetail()
  },
  components: {},
  methods: {
    //  获取通知公告详情
    async getDetail() {
      let _data = await noticeDetail(this.$route.params.id)
      this.title = _data.data.title
      this.time = zhDate(_data.data.update_time * 1000)
      this.content = _data.data.content
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.notice-title {
  font-size: 30px;
  text-align: center;
  line-height: 40px;
  margin-bottom: 20px;
}
.notice-time{
  text-align: center;
  line-height: 40px;
  color: #999;
  margin-bottom: 30px;
}
</style>